import { Injectable } from '@angular/core';
import { from, switchMap, map } from 'rxjs';
import { Observable } from 'rxjs';
import { CryptoService } from './crypto.service';
import { environment } from 'src/environments/environment';
import { API_ENDPOINTS } from 'src/app/config/api-endpoints';
import { EncryptedSecretResponseDto } from 'src/app/model/encryption/encrypted-secret-response.model';
import { HttpService } from '../http-service/http.service';

@Injectable({ providedIn: 'root' })
export class SecretService {
  private secretStore = new Map<string, string>();

  constructor(
    private http: HttpService,
    private crypto: CryptoService
  ) {}

  loadSecrets(keys: string[]): Observable<void> {
    const url =  `${environment.apiBaseURL}${API_ENDPOINTS.workpaperConfig.getWorkpaperPassword}`; //  Use the endpoint directly
    return this.http.post<string[], EncryptedSecretResponseDto[]>(url, keys).pipe(
      switchMap((encryptedSecrets) =>
        from(
          Promise.all(
            encryptedSecrets.map(async ({ Key, CipherText, IV, AesKey }) => {
              const plainText = await this.crypto.decrypt(CipherText, IV,AesKey);
              this.secretStore.set(Key, plainText);
            })
          )
        )
      ),
      map(() => void 0)
    );
  }
  getSecret(key: string): string | undefined {
    return this.secretStore.get(key);
  }
  hasSecret(key: string): boolean {
        return this.secretStore.has(key);
  }
}
